/**
 * ສະແຕັພພິມ A4 ສໍາລັບຕາຕະລາງຜົນຕອບຟອມ (ເກັບເປັນ PDF ແມ່ນຜ່ານ Print → Save as PDF).
 */

export function escapeHtmlForPrintUnsafeContext(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export const FORM_RESPONSES_PRINT_STYLES_A4 = `
  @media print {
    @page {
      size: A4 portrait;
      margin: 12mm;
    }
    thead {
      display: table-header-group;
    }
    tr {
      break-inside: avoid;
      page-break-inside: avoid;
    }
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }

  * { box-sizing: border-box; }
  body {
    margin: 0;
    padding: 10mm 12mm;
    font-family:
      ui-sans-serif,
      system-ui,
      sans-serif,
      "Apple Color Emoji",
      "Segoe UI Emoji";
    font-size: 10px;
    line-height: 1.45;
    color: #0a0a0a;
    background: #fff;
  }

  .frp-header {
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #404040;
  }
  .frp-brand {
    font-weight: 700;
    letter-spacing: 0.06em;
    font-size: 11px;
    color: #0a0a0a;
  }
  .frp-title {
    margin: 4px 0 0;
    font-size: 16px;
    font-weight: 700;
    color: #111;
  }
  .frp-meta {
    margin: 8px 0 0;
    font-size: 10px;
    color: #333;
  }

  table.fr-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }

  table.fr-table th {
    vertical-align: top;
    word-wrap: break-word;
    overflow-wrap: break-word;
    background: #f5f5f5;
    font-weight: 700;
    text-align: left;
    padding: 6px 8px;
    border: 1px solid #333;
    font-size: 10px;
  }

  table.fr-table td {
    vertical-align: top;
    word-wrap: break-word;
    overflow-wrap: break-word;
    padding: 6px 8px;
    border: 1px solid #404040;
    font-size: 10px;
  }

  table.fr-table td.mono {
    white-space: nowrap;
  }

  a.frp-file-link {
    color: #0a0a0a;
    text-decoration: underline;
    word-break: break-all;
  }

  table.fr-table tbody tr:nth-child(even) {
    background-color: #fafafa;
  }

  .frp-footer {
    margin-top: 12px;
    font-size: 10px;
    color: #333;
    border-top: 1px solid #ccc;
    padding-top: 8px;
  }
`;
